const _BROWSER_GA_MEASUREMENT_ID = 'UA-136104257-1';
const _BROWSER_GA4_MEASUREMENT_ID = 'G-1YB5SWQ7NP';


function analyticsPush()
{
    dataLayer.push(arguments);
}

function analyticsSendPage(title, location)
{
    analyticsPush('event', 'page_view',
            {
                page_title: title,
                page_location: location
            });
}

function analyticsInit(sendPageView = true)
{
    let script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=" + _BROWSER_GA_MEASUREMENT_ID;
    script.async = true;
    document.head.append(script);

    window.dataLayer = window.dataLayer || [];
    analyticsPush('js', new Date());
    analyticsPush('config', _BROWSER_GA4_MEASUREMENT_ID, {'send_page_view': sendPageView});
}

export { analyticsInit, analyticsSendPage, analyticsPush };

